import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './styles/_colors.scss';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import FirebaseConfig from './config/firebase-config.json';

// Initialize Firebase
firebase.initializeApp(FirebaseConfig.initial)
firebase.analytics();

const store = configureStore({});

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
